import React from 'react';

import { MuiThemeProvider } from '@material-ui/core';

import { materialUIPickerTheme } from 'helpers/MUIFiles';
import { AccentColor } from 'helpers/AccentColorHelper';

import { DateTimePicker } from 'material-ui-pickers';

import moment from 'moment';

export const DateTimePickerRedux = props => {
  const {
    timezone,
    showErrorsInline,
    dispatch,
    input: { onChange, value },
    meta: { touched, error },
    ...other
  } = props;

  const showError = showErrorsInline || touched;
  const valueWithTimeZone = value ? moment(value) : null;

  return (
    <MuiThemeProvider theme={materialUIPickerTheme(AccentColor())}>
      <DateTimePicker
        error={!!(showError && error)}
        helperText={showError && error}
        value={valueWithTimeZone}
        onChange={onChange}
        clearable
        {...other}
      />
    </MuiThemeProvider>
  );
};
